module.exports = __webpack_public_path__ + "img/p8.767b793d.png";